import classNames from 'classnames';
import React, { ElementType } from 'react';
import { useIds } from '../helpers/hooks';
import FlatCard, { FlatCardText } from './FlatCard';

export type MiniCardData = {
  title: string;
  valid: string;
  value: string;
  minivalue: string;
  link: string | { link: string; data: object };
  icon: string;
  iconType: string;
  iconColor: string;
  backgroundColor: string;
  borderColor: string;
  titleData: FlatCardText;
  subTitleData: FlatCardText;
};

type MiniCardsProps = {
  minicards: MiniCardData[];
  as?: ElementType;
  full?: boolean;
  className?: string;
  headerTitle?: string;
};

const MiniCards = ({
  minicards,
  as: Container = 'div',
  className = '',
  full = false,
  headerTitle = '',
}: MiniCardsProps) => {
  const ids = useIds(minicards.length);
  if (!minicards.length) {
    return null;
  }
  return (
    <Container className={classNames('flex flex-wrap justify-between flex-shrink-0', className)}>
      {headerTitle && <h3 className='font-body uppercase text-xs text-gray-600 mb-2 w-full'>{headerTitle}</h3>}
      {minicards.map(
        (
          {
            title,
            value,
            minivalue,
            link,
            icon,
            iconType,
            iconColor,
            backgroundColor,
            borderColor,
            titleData,
            subTitleData,
          },
          index,
        ) => (
          <FlatCard
            containerClassName={classNames(full ? 'w-full' : 'w-1/2-2', 'p-2 mb-4')}
            key={ids[index]}
            title={{
              text: title,
              fontSize: 'small',
              className: 'text-gray-500',
              ...titleData,
            }}
            subTitle={{
              text: (
                <>
                  <span className={classNames(minivalue && 'text-base font-bold')}>{value}</span>
                  {minivalue && <span>{' ' + (minivalue.includes('%') ? '' : minivalue)}</span>}
                </>
              ),
              className: 'text-gray-800',
              ...subTitleData,
            }}
            link={typeof link === 'string' ? link : link?.link ?? ''}
            linkData={typeof link === 'string' ? {} : link?.data ?? {}}
            iconLeft={{
              type: iconType,
              name: icon,
              color: iconColor,
              marginRight: '0.5rem',
            }}
            feel={{
              backgroundColor,
              borderColor,
            }}
          />
        ),
      )}
    </Container>
  );
};

export default MiniCards;
